'use client';

import { useBranding } from '@/hooks/useBranding';

/** Nome do sistema (Configurações → Gerais). */
export function useSystemName(): string {
  return useBranding().nomeSistema;
}
